import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import './tariff.scss';
import { Button, Icons } from '../../../components/base/BootstrapComponents';
import { getTariffData } from '../reducer';
import {
  deleteCalendarDate,
  loadCalendarDateByIdClear,
  loadCalendarDateList,
  loadCalendarDateById,
} from '../actions';
import PageHeader from '../../../components/base/PageHeader/PageHeader';
import {
  responseLogWithNotification,
  getPaginationOpts,
  getJsonFromStorage,
  useUpdatePeriod,
} from '../../../utils/utils';
import Loader from '../../../components/base/Loader/Loader';
import { getSystemData } from '../../System/reducer';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import { tariffPresetColumns } from '../constants';
import Pagination from '../../../components/base/Pagination/Pagination';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import { showGlobalConfirm } from '../../System/actions';
import notificationDecorator from '../../Notifications/notificationDecorator';
import IconBox from '../../../components/common/IconBox';
import CalendarDateForm from './CalendarDateForm';

export default function CalendarDatePage() {
  const dispatch = useDispatch();
  const [isCreate, setCreate] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showView, setShowView] = useState(false);
  const {
    calendarDateList,
    calendarDateListMeta,
    currentCalendarDate,
    loadingCalendarDateList,
    loadingCurrentCalendarDate,
    loadingCreateCalendarDate,
    loadingEditCalendarDate,
    loadingDeleteCalendarDate,
  } = useSelector(getTariffData);

  const { updatePeriod } = useSelector(getSystemData);

  const initial = getJsonFromStorage('tariff-filter', {});
  const { getValues, watch } = useForm({ defaultValues: { ...initial } });

  const loadData = opts => {
    const filterData = getValues();
    const paginationOpts = getPaginationOpts(calendarDateListMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: filterData,
    };
    const p1 = dispatch(loadCalendarDateList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const [setPeriod, destroy] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => {
    setPeriod(updatePeriod);
    return destroy;
  }, [updatePeriod]);

  useEffect(() => {
    const tariff = watch(values => { loadData(); });
    return () => tariff.unsubscribe();
  }, [watch]);

  const handleCreate = () => {
    setCreate(true);
    setShowForm(true);
  };

  const handleView = item => e => {
    handleClose();
    dispatch(loadCalendarDateById(item.id))
      .then(() => {
        setShowView(true);
      })
      .catch(responseLogWithNotification);
    e.preventDefault();
    e.stopPropagation();
  };

  const handleEdit = item => e => {
    handleClose();
    dispatch(loadCalendarDateById(item.id))
      .then(() => {
        setShowForm(true);
      })
      .catch(responseLogWithNotification);
    e?.preventDefault();
    e?.stopPropagation();
  };

  const handleActive = item => e => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDelete = item => e => {
    const calendarDateLabel = item?.date ? ` ${item.date}` : '';

    dispatch(showGlobalConfirm({
      confirmTitle: 'Удаление рабочего дня',
      confirmMessage: `Вы уверены, что хотите удалить рабочий день${calendarDateLabel}?`,
      confirmButtonText: 'Удалить',
    })).then(() => {
      dispatch(deleteCalendarDate(item.id))
        .then(() => {
          loadData();
          notificationDecorator({
            title: 'Удаление рабочего дня',
            message: 'Успешно',
          });
        })
        .catch(responseLogWithNotification);
    }).catch(() => {});
    e.preventDefault();
    e.stopPropagation();
  };

  const handleClose = () => {
    dispatch(loadCalendarDateByIdClear());
    setShowForm(false);
    setShowView(false);
    setCreate(false);
  };

  const handleSaved = () => {
    handleClose();
    loadData();
  };

  const moreFormatter = (_, item) => (
    <TooltipWithPortal
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="more-actions"
      tooltipContent={(
        <div className="more-wrapper">
          <Button variant="link" className="w-100 more-button" onClick={handleView(item)}>
            Просмотреть
          </Button>
          <Button variant="link" className="w-100 more-button" onClick={handleEdit(item)}>
            Редактировать
          </Button>
          {/* <Button variant="link" className="w-100 more-button delete" onClick={handleActive(item)}> */}
          {/*  {item?.is_active ? 'Деактивировать ' : 'Активировать'} */}
          {/* </Button> */}
          <Button variant="link" className="w-100 more-button delete" onClick={handleDelete(item)}>
            Удалить
          </Button>
        </div>
      )}
      classNameWrapper="more-tooltip-wrapper"
      className="more-tooltip"
    />
  );

  const renderList = () => (
    <div className="page-container">
      <div className="inputs-box">
        <PageHeader header="Рабочий календарь" />
        <div className="inputs">
          <IconBox icon="plus-add" onClick={handleCreate} />
        </div>
      </div>
      <div className="plp-table g-0">
        <div className="frame">
          <div className="sticky-table-wrapper custom-scroll-theme">
            <CustomizedGrid
              className="plp-grid"
              data={calendarDateList}
              columns={tariffPresetColumns}
              name="calendar-date-list"
              settingsFormatter={moreFormatter}
              onDoubleClickByRow={(item, event) => handleView(item)(event)}
            />
          </div>
        </div>
        <Pagination meta={calendarDateListMeta} list={calendarDateList} handleChangeMeta={loadData} />
      </div>
    </div>
  );

  const isForm = showForm && (currentCalendarDate || isCreate);
  const isView = showView && currentCalendarDate;

  return (
    <div className="tariff-tab">
      <Loader global loading={loadingCalendarDateList || loadingCurrentCalendarDate || loadingCreateCalendarDate || loadingEditCalendarDate || loadingDeleteCalendarDate} />
      {!isForm && !isView ? renderList() : null}
      {!isForm && isView ? <CalendarDateForm hasView handleEdit={handleEdit} handleClose={handleClose} /> : null}
      {isForm && !isView ? <CalendarDateForm handleSaved={handleSaved} handleEdit={handleEdit} handleClose={handleClose} /> : null}
    </div>
  );
}
